// extracted by mini-css-extract-plugin
export default {"fileRendererViewport":"RichDiff-module__fileRendererViewport--Pf7Yx","fileRendererIframe":"RichDiff-module__fileRendererIframe--uFDQV"};